var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticStyle: { "background-color": "#DFE0E2 !important" },
      attrs: { id: "app" }
    },
    [
      _c(
        "b-navbar",
        { staticClass: "sf-navbar", attrs: { toggleable: "md", fixed: "top" } },
        [
          _c("b-navbar-toggle", { attrs: { target: "nav_collapse" } }),
          _vm._v(" "),
          _c(
            "b-navbar-brand",
            { staticClass: "sf-navbar", attrs: { to: "/" } },
            [
              _c("b-img", {
                staticClass: "navbar-img-logo",
                attrs: { src: "/static/thebrainlogo.png" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-collapse",
            {
              staticClass: "pl-3",
              attrs: { "is-nav": "", id: "nav_collapse" }
            },
            [
              _c(
                "b-navbar-nav",
                [
                  _c(
                    "b-navbar-brand",
                    {
                      staticClass: "sf-navbar",
                      attrs: { to: "/scoring-events" }
                    },
                    [
                      _c("b-img", {
                        staticClass: "navbar-img",
                        attrs: { src: "/static/Grow.png" }
                      }),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v("\n          Scoring Events\n        ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-navbar-brand",
                    { staticClass: "sf-navbar", attrs: { to: "/wizard" } },
                    [
                      _c("b-img", {
                        staticClass: "navbar-img",
                        attrs: { src: "/static/Ruler.png" }
                      }),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v("\n          Import Survey Data\n        ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-navbar-brand",
                    {
                      staticClass: "sf-navbar",
                      attrs: { to: "/new-scoring-event" }
                    },
                    [
                      _c("b-img", {
                        staticClass: "navbar-img",
                        attrs: { src: "/static/Ask.png" }
                      }),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v("Add Scoring Event\n        ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-navbar-brand",
                    {
                      staticClass: "sf-navbar",
                      attrs: { to: "/quick-win-recommendation-search" }
                    },
                    [
                      _c("b-img", {
                        staticClass: "navbar-img",
                        attrs: { src: "/static/Hammer.png" }
                      }),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v("\n          Quick Wins\n        ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-navbar-brand",
                    {
                      staticClass: "sf-navbar",
                      attrs: {
                        to:
                          "/quick-win-recommendation-search?type=recommendations"
                      }
                    },
                    [
                      _c("b-img", {
                        staticClass: "navbar-img",
                        attrs: { src: "/static/Screwdriver.png" }
                      }),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v("\n          Recommendations\n        ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-navbar-brand",
                    {
                      staticClass: "sf-navbar",
                      attrs: { to: "/gpc-sessions" }
                    },
                    [
                      _c("b-img", {
                        staticClass: "navbar-img",
                        attrs: { src: "/static/Spanner.png" }
                      }),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v("\n          GPC Sessions\n        ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-navbar-brand",
                    { staticClass: "sf-navbar", attrs: { to: "/smart-goals" } },
                    [
                      _c("b-img", {
                        staticClass: "navbar-img",
                        attrs: { src: "/static/pliers.png" }
                      }),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v("\n          SMART Goals\n        ")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-navbar-brand",
                    {
                      staticClass: "sf-navbar",
                      attrs: { to: "/industry-data" }
                    },
                    [
                      _c("b-img", {
                        staticClass: "navbar-img",
                        attrs: { src: "/static/Think.png" }
                      }),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v("\n          Industry Data\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "b-container",
        { staticClass: "mt-4 pt-2 pb-2 pl-2 pr-2" },
        [
          _c(
            "b-row",
            { staticClass: "text-center", attrs: { "align-h": "center" } },
            [
              !_vm.$root.surveyMonkeyCode && !_vm.$root.token
                ? _c(
                    "a",
                    {
                      staticClass: "btn btn-primary surveymonkey mt-2 mb-2",
                      attrs: { href: _vm.$root.SURVEY_MONKEY_URL }
                    },
                    [_vm._v("Survey Monkey Sign-In")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.$root.surveyMonkeyCode &&
                      !_vm.$root.token &&
                      !_vm.loggingIn,
                    expression:
                      "$root.surveyMonkeyCode && !$root.token && !loggingIn"
                  }
                ],
                attrs: {
                  id: "g_id_onload",
                  "data-client_id": _vm.googleClientId,
                  "data-context": "signin",
                  "data-ux_mode": "popup",
                  "data-callback": "handleGoogleResponse",
                  "data-auto_prompt": "false"
                }
              }),
              _vm._v(" "),
              _c("div", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.$root.surveyMonkeyCode &&
                      !_vm.$root.token &&
                      !_vm.loggingIn,
                    expression:
                      "$root.surveyMonkeyCode && !$root.token && !loggingIn"
                  }
                ],
                staticClass: "g_id_signin",
                attrs: {
                  "data-type": "standard",
                  "data-shape": "pill",
                  "data-theme": "outline",
                  "data-text": "signin_with",
                  "data-size": "large",
                  "data-logo_alignment": "left"
                }
              }),
              _vm._v(" "),
              _vm.loggingIn
                ? _c(
                    "div",
                    [
                      _c("font-awesome-icon", {
                        staticClass: "mt-2 mb-2",
                        attrs: { icon: "spinner", size: "lg", spin: "" }
                      }),
                      _vm._v(" Logging in....")
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("router-view")
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticStyle: { height: "200px" } },
            [
              _c("b-img", {
                staticClass: "pl-2 pr-2 pb-2 auto-img",
                attrs: { src: "/static/squiggle-large.jpg" }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("br")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 